/// <reference path="../_all.ts" />

declare var pglob : IPhotometerGlobalVar;

module library {
  'use strict';
  
  export class ToolboxCtrl {

    public static $inject = [
      '$scope'
      , '$timeout'
      , '$interval'
    ];

    constructor(
      private $scope: any
      , private $timeout: ng.ITimeoutService
      , private $interval: ng.IIntervalService
      ) {

      $scope.vm = this;
      
    }
    
    public init(data :  any) {
      data.forEach((t, i, a) => {
        t.subObj = [];
        t.sub.forEach((sub, j, a) => {
          t.subObj.push({
            "id" : j,
            "name" : sub
          });
        });
      });
      this.$scope.historyData = data;
      if (this.$scope.historyData) this.$scope.entry = this.$scope.historyData[0];
    }

    
  }
}